import { Button, ButtonProps } from '@/shared/components/ui/button';

export const FilterButton = ({
  activeCount,
  ...props
}: ButtonProps & { activeCount?: number }) => {
  return (
    <Button shape="square" variant={'outline'} btnType="secondary" {...props}>
      <CustomFilterIcon />

      {activeCount && activeCount > 0 ? (
        <span className="inline-flex h-4 min-h-4 w-4 min-w-4 items-center justify-center rounded-full bg-custom-green text-[10px] font-semibold text-black">
          {activeCount}
        </span>
      ) : null}
    </Button>
  );
};

const CustomFilterIcon = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.5225C4.54688 16.5225 0.929688 12.9053 0.929688 8.45215C0.929688 3.99902 4.54688 0.381836 9 0.381836C13.4531 0.381836 17.0703 3.99902 17.0703 8.45215C17.0703 12.9053 13.4531 16.5225 9 16.5225ZM9 14.9287C12.5859 14.9287 15.4844 12.0381 15.4844 8.45215C15.4844 4.86621 12.5859 1.96777 9 1.96777C5.41406 1.96777 2.51562 4.86621 2.51562 8.45215C2.51562 12.0381 5.41406 14.9287 9 14.9287ZM4.90625 6.95996C4.51562 6.95996 4.25 6.71777 4.25 6.35059C4.25 5.9834 4.51562 5.7334 4.90625 5.7334H13.1016C13.4922 5.7334 13.7656 5.9834 13.7656 6.35059C13.7656 6.71777 13.4922 6.95996 13.1016 6.95996H4.90625ZM5.99219 9.5459C5.60156 9.5459 5.32812 9.2959 5.32812 8.92871C5.32812 8.56152 5.60156 8.31152 5.99219 8.31152H12.0234C12.4062 8.31152 12.6797 8.56152 12.6797 8.92871C12.6797 9.2959 12.4062 9.5459 12.0234 9.5459H5.99219ZM7.11719 12.124C6.72656 12.124 6.45312 11.8818 6.45312 11.5146C6.45312 11.1475 6.72656 10.8975 7.11719 10.8975H10.8906C11.2812 10.8975 11.5547 11.1475 11.5547 11.5146C11.5547 11.8818 11.2812 12.124 10.8906 12.124H7.11719Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};
